import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      membership: 'Membership',
      events: 'Events',
      contact: 'Contact'
    },
    home: {
      heroTitle: 'A global network, local execution, absolute discretion',
      heroSubtitle: 'JSX International & Henry & Gaby',
      heroDescription: 'Elite solutions for sensitive global operations',
      ctaPrimary: 'Discover the network',
      ctaSecondary: 'Contact us',
      aboutTitle: 'A unique alliance between consulting, mobility and prestige',
      aboutP1: 'JSX International is a private consulting firm specializing in sensitive international operations, strategic representation and business development.',
      aboutP2: 'Henry & Gaby is a private business club offering its members privileged access to private jet flights, exclusive stays and prestigious events.',
      feature1: 'Multi-sector expertise',
      feature1Desc: 'Finance, energy, luxury, diplomacy',
      feature2: 'International network',
      feature2Desc: 'Partners and operators worldwide',
      feature3: 'Confidential services',
      feature3Desc: 'Personalized and highly secure',
      feature4: 'Unique access',
      feature4Desc: 'Economic and cultural opportunities',
      networkTitle: 'Discover the Network',
      networkSubtitle: 'A global network, local execution, absolute discretion. JSX International and Henry & Gaby form a unique strategic alliance, serving the most sensitive operations and the most demanding ambitions.',
      networkSection1Title: 'International presence, local connections',
      networkSection1Desc: 'Our network relies on partners present in the world\'s economic, diplomatic and cultural capitals. Each mission is orchestrated with precision, in absolute respect of confidentiality.',
      networkSection2Title: 'Multi-sector expertise',
      networkSection2Desc: 'We operate in key sectors — finance, energy, luxury, diplomacy — with a tailor-made approach and high value-added solutions.',
      networkSection3Title: 'Mobility and privileges',
      networkSection3Desc: 'Thanks to Henry & Gaby, our members benefit from exclusive access to:',
      networkSection3Item1: 'Private jet flights',
      networkSection3Item2: 'Confidential stays',
      networkSection3Item3: 'Prestigious events',
      networkSection3Item4: 'Reserved economic and cultural opportunities',
      networkSection4Title: 'Confidential and personalized services',
      networkSection4Desc: 'Every intervention is thought out in the smallest details: security, discretion, efficiency. We operate where others do not go.',
      networkCta: 'Join an elite circle. Discover how our network can become yours.'
    },
    services: {
      title: 'Strategic Consulting & Operations',
      subtitle: 'We support companies, institutions and individuals in their complex international projects',
      service1: 'Technical & Commercial Representation',
      service1Desc: 'Connection with distributors, suppliers, partners abroad',
      service2: 'International Transactions',
      service2Desc: 'Legal, logistics and customs security',
      service3: 'Secure Transport',
      service3Desc: 'Precious metals, sensitive documents, VIP transport',
      service4: 'Commodities Consulting',
      service4Desc: 'Hydrocarbons and raw materials operations',
      service5: 'Medical Transport',
      service5Desc: 'Medical or VIP transport by private aircraft',
      service6: 'Private Seminars',
      service6Desc: 'Confidential meetings between high-level decision-makers',
      confidentiality: 'Contractual confidentiality guaranteed',
      network: 'Premium network of operators',
      quote: 'We intervene where others cannot go',
      caption1: 'Travel Optimization',
      caption2: 'Private Seminars',
      caption3: 'Business Networking and Support'
    },
    membership: {
      title: 'Henry & Gaby Club',
      subtitle: 'Three cards, a world of benefits',
      heroTitle: 'Three cards, a world of benefits',
      heroDescription: 'Welcome to Club Privé Henry & Gaby, an exceptional place reserved for a discerning elite, where luxury and exclusivity meet to offer an unparalleled experience to its members. Discover a universe where discretion, confidentiality and high-end services are at the heart of our offerings.',
      welcome: 'Welcome to Club Privé Henry & Gaby, an exceptional place reserved for a discerning elite, where luxury and exclusivity meet to offer an unparalleled experience to its members. Discover a universe where discretion, confidentiality and high-end services are at the heart of our offerings.',
      exclusive: 'Membership by recommendation only',
      business: 'Business Card',
      businessPrice: '€5,000 /year',
      businessFeature1: 'Access to Private Jet flight programs',
      businessFeature2: 'Professional seminars',
      businessFeature3: 'Business afterworks',
      businessFeature4: 'Priority support',
      magellan: 'Magellan Card',
      magellanPrice: '€7,500 /year',
      magellanFeature1: 'All Business benefits',
      magellanFeature2: 'Exclusive stays',
      magellanFeature3: 'Enhanced networking',
      magellanFeature4: 'VIP access to events',
      orlamonde: 'Orlamonde Card',
      orlamondePrice: '€50,000 /year',
      orlamondeFeature1: 'All Magellan benefits',
      orlamondeFeature2: 'Specific Private Jet flight programs',
      orlamondeFeature3: '24/7 concierge',
      orlamondeFeature4: 'Exclusive VIP events',
      cta: 'Request information',
      quote: 'Join an elite circle where every detail is designed for you',
      additionalInfo: 'Club Henry & Gaby is not only about organizing private flights, but is also a key player in various events such as sporting events, gala evenings, concerts, recitals, fashion shows, tastings, golf outings and many other private events.'
    },
    events: {
      title: 'Exclusive Events & Experiences',
      subtitle: 'Where luxury meets strategy',
      type1: 'Marco Polo Seminars',
      type1Desc: 'Expert panels, thematic workshops, high-level networking',
      type2: 'Private Dinners',
      type2Desc: 'Intimate gatherings with investors, bankers, executives',
      type3: 'VIP Access',
      type3Desc: 'Cannes Film Festival, Monaco Grand Prix, Art Basel, yachting',
      type4: 'Afterworks',
      type4Desc: 'Weekly events in Paris, Riviera, across Europe',
      destination1: 'Paris - Geneva',
      destination1Price: '€1,900',
      destination2: 'Paris - Cannes',
      destination2Price: '€2,450 - €3,590',
      destination3: 'Paris - Barcelona',
      destination3Price: '€2,990',
      perPerson: 'per person round trip',
      cta: 'View calendar'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch for exclusive opportunities',
      address: '20, rue des Capucins',
      city: '77160 Provins, France',
      phone: '+33 6 41 66 42 58',
      hours: 'Monday - Friday: 9:00 - 18:00',
      quote: 'Every moment becomes an unforgettable experience'
    },
    footer: {
      about: 'About',
      aboutText: 'Elite solutions for sensitive global operations. A global network, local execution, absolute discretion.',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      legal: 'Legal Notice',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      rights: 'All rights reserved'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      membership: 'Adhésion',
      events: 'Événements',
      contact: 'Contact'
    },
    home: {
      heroTitle: 'Un réseau mondial, une exécution locale, une discrétion absolue',
      heroSubtitle: 'JSX International & Henry & Gaby',
      heroDescription: 'Solutions d\'élite pour des opérations mondiales sensibles',
      ctaPrimary: 'Découvrir le réseau',
      ctaSecondary: 'Nous contacter',
      aboutTitle: 'Une alliance unique entre conseil, mobilité et prestige',
      aboutP1: 'JSX International est un cabinet de conseil privé spécialisé dans les opérations internationales sensibles, la représentation stratégique et le développement commercial.',
      aboutP2: 'Henry & Gaby est un club d\'affaires privé qui offre à ses membres un accès privilégié à des vols en jet privé, des séjours exclusifs et des événements de prestige.',
      feature1: 'Expertise multisectorielle',
      feature1Desc: 'Finance, énergie, luxe, diplomatie',
      feature2: 'Réseau international',
      feature2Desc: 'Partenaires et opérateurs mondiaux',
      feature3: 'Services confidentiels',
      feature3Desc: 'Personnalisés et hautement sécurisés',
      feature4: 'Accès unique',
      feature4Desc: 'Opportunités économiques et culturelles',
      networkTitle: 'Découvrir le réseau',
      networkSubtitle: 'Un réseau mondial, une exécution locale, une discrétion absolue. JSX International et Henry & Gaby forment une alliance stratégique unique, au service des opérations les plus sensibles et des ambitions les plus exigeantes.',
      networkSection1Title: 'Une présence internationale, des connexions locales',
      networkSection1Desc: 'Notre réseau s\'appuie sur des partenaires présents dans les capitales économiques, diplomatiques et culturelles du monde entier. Chaque mission est orchestrée avec précision, dans le respect absolu de la confidentialité.',
      networkSection2Title: 'Expertise multisectorielle',
      networkSection2Desc: 'Nous intervenons dans des secteurs clés — finance, énergie, luxe, diplomatie — avec une approche sur mesure et des solutions à haute valeur ajoutée.',
      networkSection3Title: 'Mobilité et privilèges',
      networkSection3Desc: 'Grâce à Henry & Gaby, nos membres bénéficient d\'un accès exclusif à :',
      networkSection3Item1: 'Vols en jet privé',
      networkSection3Item2: 'Séjours confidentiels',
      networkSection3Item3: 'Événements de prestige',
      networkSection3Item4: 'Opportunités économiques et culturelles réservées',
      networkSection4Title: 'Services confidentiels et personnalisés',
      networkSection4Desc: 'Chaque intervention est pensée dans les moindres détails : sécurité, discrétion, efficacité. Nous opérons là où les autres ne vont pas.',
      networkCta: 'Rejoignez un cercle d\'élite. Découvrez comment notre réseau peut devenir le vôtre.'
    },
    services: {
      title: 'Conseil stratégique & opérations',
      subtitle: 'Nous accompagnons les entreprises, institutions et particuliers dans leurs projets internationaux complexes',
      service1: 'Représentation technique & commerciale',
      service1Desc: 'Mise en relation avec distributeurs, fournisseurs, partenaires à l\'étranger',
      service2: 'Transactions internationales',
      service2Desc: 'Sécurisation juridique, logistique et douane',
      service3: 'Transport sécurisé',
      service3Desc: 'Métaux précieux, documents sensibles, transport VIP',
      service4: 'Conseil matières premières',
      service4Desc: 'Opérations hydrocarbures et matières premières',
      service5: 'Transport sanitaire',
      service5Desc: 'Transport sanitaire ou VIP par avion privé',
      service6: 'Séminaires privés',
      service6Desc: 'Rencontres confidentielles entre décideurs de haut niveau',
      confidentiality: 'Confidentialité contractuelle garantie',
      network: 'Réseau premium d\'opérateurs',
      quote: 'Nous intervenons là où les autres ne peuvent pas aller',
      caption1: 'Optimisation des déplacements',
      caption2: 'Séminaires privés',
      caption3: 'Réseautage d\'Affaires et Accompagnement'
    },
    membership: {
      title: 'Club Henry & Gaby',
      subtitle: 'Trois cartes, un monde d\'avantages',
      heroTitle: 'Trois cartes, un monde d\'avantages',
      heroDescription: 'Bienvenue au Club Privé Henry & Gaby, un lieu d\'exception réservé à une élite discernée, où le luxe et l\'exclusivité se rencontrent pour offrir une expérience inégalée à ses membres. Découvrez un univers où discrétion, confidentialité et prestations haut de gamme sont au cœur de nos services.',
      welcome: 'Bienvenue au Club Privé Henry & Gaby, un lieu d\'exception réservé à une élite discernée, où le luxe et l\'exclusivité se rencontrent pour offrir une expérience inégalée à ses membres. Découvrez un univers où discrétion, confidentialité et prestations haut de gamme sont au cœur de nos services.',
      exclusive: 'Adhésion sur recommandation uniquement',
      business: 'Carte Business',
      businessPrice: '5 000 € /an',
      businessFeature1: 'Accès aux programmes vols en Jet Privés',
      businessFeature2: 'Séminaires professionnels',
      businessFeature3: 'Afterworks d\'affaires',
      businessFeature4: 'Support prioritaire',
      magellan: 'Carte Magellan',
      magellanPrice: '7 500 € /an',
      magellanFeature1: 'Tous les avantages Business',
      magellanFeature2: 'Séjours exclusifs',
      magellanFeature3: 'Networking renforcé',
      magellanFeature4: 'Accès VIP aux événements',
      orlamonde: 'Carte Orlamonde',
      orlamondePrice: '50 000 € /an',
      orlamondeFeature1: 'Tous les avantages Magellan',
      orlamondeFeature2: 'Programmes vols en Jet Privés spécifiques',
      orlamondeFeature3: 'Conciergerie 24/7',
      orlamondeFeature4: 'Événements VIP exclusifs',
      cta: 'Demander des informations',
      quote: 'Rejoignez un cercle d\'élite où chaque détail est pensé pour vous',
      additionalInfo: 'Le Club Henry & Gaby ne se contente pas seulement d\'organiser des vols privés, mais est également un acteur incontournable lors de diverses manifestations telles que des rencontres sportives, des soirées de gala, des concerts, des récitals, des défilés, des dégustations, des parties de golf et bien d\'autres événements privés.'
    },
    events: {
      title: 'Événements exclusifs & expériences',
      subtitle: 'Là où le luxe rencontre la stratégie',
      type1: 'Séminaires Marco Polo',
      type1Desc: 'Panels d\'experts, ateliers thématiques, networking de haut niveau',
      type2: 'Dîners privés',
      type2Desc: 'Rencontres intimes avec investisseurs, banquiers, dirigeants',
      type3: 'Accès VIP',
      type3Desc: 'Festival de Cannes, Grand Prix de Monaco, Art Basel, yachting',
      type4: 'Afterworks',
      type4Desc: 'Événements hebdomadaires à Paris, Riviera, en Europe',
      destination1: 'Paris - Genève',
      destination1Price: '1 900 €',
      destination2: 'Paris - Cannes',
      destination2Price: '2 450 - 3 590 €',
      destination3: 'Paris - Barcelone',
      destination3Price: '2 990 €',
      perPerson: 'par personne aller-retour',
      cta: 'Voir le calendrier'
    },
    contact: {
      title: 'Nous contacter',
      subtitle: 'Contactez-nous pour des opportunités exclusives',
      address: '20, rue des Capucins',
      city: '77160 Provins, France',
      phone: '+33 6 41 66 42 58',
      hours: 'Lundi - Vendredi : 9h00 - 18h00',
      quote: 'Chaque moment devient une expérience inoubliable'
    },
    footer: {
      about: 'À propos',
      aboutText: 'Solutions d\'élite pour des opérations mondiales sensibles. Un réseau mondial, une exécution locale, une discrétion absolue.',
      quickLinks: 'Liens rapides',
      contact: 'Contact',
      legal: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
      rights: 'Tous droits réservés'
    }
  }
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'fr' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};